import { findCustomerValue } from '@api/reports';
import {
  CustomerValueResponse,
  CustomerValueRow,
  CustomerValueTotals,
} from '@interfaces/reports/customerValue';
import { PaymentConversionPeriod } from '@interfaces/reports/paymentConversion';
import { ReportFiltersInput, useReportRequest } from '../useReportRequest';

export const emptyTotals: CustomerValueTotals = {
  buyers: 0,
  purchases: 0,
  purchasesPerBuyer: 0,
  revenue: 0,
  ltv: 0,
  firstPurchaseRevenue: 0,
  averageFirstTicket: 0,
  repeatBuyers: 0,
  repeatRate: 0,
  crossSellBuyers: 0,
  crossSellRate: 0,
  averageDaysToRepeat: 0,
  averageDaysObserved: 0,
};

export const emptyResponse: CustomerValueResponse = {
  rows: [],
  totals: emptyTotals,
};

const normaliseRow = (row: Partial<CustomerValueRow>): CustomerValueRow => ({
  ...emptyTotals,
  ...row,
  period: row.period ?? '',
});

export function useCustomerValue(
  filters: ReportFiltersInput,
  timeAggregationPeriod: PaymentConversionPeriod = 'MONTH',
) {
  const { data, isLoading, hasFailed } = useReportRequest<CustomerValueResponse>(
    filters,
    timeAggregationPeriod,
    findCustomerValue as any,
    emptyResponse,
    (payload) => ({
      rows: (payload.rows ?? []).map(normaliseRow),
      totals: { ...emptyTotals, ...(payload.totals ?? {}) },
    }),
  );

  return { rows: data.rows, totals: data.totals, isLoading, hasFailed };
}
